import { a as u } from "./query-DolxHPXs.js";
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function f(e) {
  return (a, i) => {
    const { slot: r, selector: n } = e != null ? e : {}, l = "slot" + (r ? `[name=${r}]` : ":not([name])");
    return u(a, i, { get() {
      var o, c;
      const t = (o = this.renderRoot) == null ? void 0 : o.querySelector(l), s = (c = t == null ? void 0 : t.assignedElements(e)) != null ? c : [];
      return n === void 0 ? s : s.filter((m) => m.matches(n));
    } });
  };
}
export {
  f as o
};
